// This file was autogenerated from /frontend/sail-next/packages/docs/src/examples/Tooltip/Delay.story.tsx with go/sail-next-tailor-docs-publisher 

import React from 'react';
import { Button, Tooltip } from '@sail/ui';
export const Delay = () => <Tooltip delay={0} trigger={<Button onPress={undefined}>Immediate</Button>}>
    I showed up immediately.
  </Tooltip>;